import React from 'react';

export default function KoobParagraph({ childClass, size = 'base', children }) {
  return (
    <p className={`text-${size} font-light text-k-p ${childClass}`}>
      {children}
    </p>
  );
}
